import { create } from 'zustand'

const initBridge = {
  state: 'idle',             // 'idle' | 'starting' | 'running' | 'done' | 'error'
  progress: 0,               // 0..1
  phase: 0,
  isFirstForBusiness: false,
  startedAt: null,
  error: null,
}

export const useBanks = create((set, get) => ({
  // === EXISTENTE ===
  banksCount: 0,
  setBanksCount: value => set(state => ({ ...state, banksCount: value })),
  getData: null,
  setGetData: getDataFunction => set(state => ({ ...state, getData: getDataFunction })),

  // === PUENTE PRIMERA CONEXIÓN ===
  bankBridge: { ...initBridge },
  startBankBridge: (isFirst = false) =>
    set(state => ({ ...state, bankBridge: { ...initBridge, state: 'starting', isFirstForBusiness: !!isFirst, startedAt: Date.now() } })),
  updateBankBridge: (patch = {}) =>
    set(state => ({ ...state, bankBridge: { ...state.bankBridge, ...patch } })),
  finishBankBridge: () =>
    set(state => ({ ...state, bankBridge: { ...state.bankBridge, state: 'done', progress: 1 } })),
  errorBankBridge: (msg) =>
    set(state => ({ ...state, bankBridge: { ...state.bankBridge, state: 'error', error: msg || 'Error desconocido' } })),
  resetBankBridge: () =>
    set(state => ({ ...state, bankBridge: { ...initBridge } })),
}))
